import { Button } from "components/DesignSystem/Button/Button";
import { useModal } from "hooks/useModal";
import { useGetLatestChurnDetailQuery } from "store/apis/salesCrm";
import { ChurnDetailsModal } from "./ChurnDetailsModal";

type ReviewChurnDetailsButtonProps = {
  groupId: string;
  hasChurnedTag: boolean;
};

export const ReviewChurnDetailsButton = ({
  groupId,
  hasChurnedTag,
}: ReviewChurnDetailsButtonProps) => {
  const reviewModal = useModal();
  // Only fetches for churned rows (see `skip`), but on a page full of churned groups
  // this is still one request per row -- moving churn-detail presence into the groups
  // list payload would let the whole page load in one request instead.
  const { data: latestChurnDetail, isLoading } = useGetLatestChurnDetailQuery(
    { groupId },
    { skip: !hasChurnedTag }
  );

  if (!hasChurnedTag) {
    return <>-</>;
  }

  const hasChurnDetails = Boolean(latestChurnDetail);

  return (
    <>
      <Button
        type="button"
        size="small"
        customType={hasChurnDetails ? "secondary" : "primary"}
        isLoading={isLoading}
        onClick={reviewModal.open}
      >
        {hasChurnDetails ? "View" : "Add"}
      </Button>
      {reviewModal.isOpen && (
        <ChurnDetailsModal
          isOpen={reviewModal.isOpen}
          close={reviewModal.close}
          groupId={groupId}
          draftId={latestChurnDetail?.uuid}
          prefetchedDraft={latestChurnDetail ?? undefined}
        />
      )}
    </>
  );
};
